import * as React from "react";
import { BetBtn } from "../BetBtn";
export class BetBtnMultiview extends BetBtn {
    renderContent() {
        return (React.createElement("div", { className: "rj-ev-list__bet-btn__inner", "data-uat": "div-ev-list-bet-btn-inner" },
            this.renderPoints(),
            this.renderOdds()));
    }
}
//# sourceMappingURL=BetBtnMultiview.js.map